import Image from "next/image";
import React, { Component } from "react";

class StepEmailContent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentStep: 1,
    };
  }

  render() {
    return (
      <>
        {" "}
        <div className="">
          <div className="signup__heading">Check your email</div>
          <div className="email__picture_section">
            {" "}
            <Image
              src="/static/images/emailPic.png"
              alt="Find a co-founder today"
              height={300}
              width={300}
              priority={true}
            />
          </div>
          <div className="email__content__section">
            <p>
              We want to make sure your email is working and you can receive
              messages -<br></br> important for when other founders reach out!
            </p>
          </div>

          <div className="tips__content__section">
            <div className="email__section__protip">
              <div className="protip__icon">
                <Image
                  width={150}
                  height={40}
                  src="/static/images/proTips.png"
                  alt=""
                />
              </div>

              <p>
                If you don’t see the email, check your spam and add
                <h4> noreply@starthawk.io</h4> to your contacts.
              </p>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default StepEmailContent;
